import { render, staticRenderFns } from "./closeTask.vue?vue&type=template&id=2af241f2&scoped=true&"
import script from "./closeTask.vue?vue&type=script&lang=js&"
export * from "./closeTask.vue?vue&type=script&lang=js&"
import style0 from "./closeTask.vue?vue&type=style&index=0&id=2af241f2&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2af241f2",
  null
  
)

export default component.exports